// Discrete "update available" banner that listens for the
// 'ss:sw-update-available' event dispatched from main.tsx when a new bundle
// has taken control. Replaces the previous behaviour of auto-reloading the
// page mid-tap.
//
// Dismissal is keyed to the BUILD HASH so:
//   - dismissing on one page hides the banner across navigations
//   - a subsequent NEW deploy (different commit hash) shows the banner
//     again — we're not silencing future updates, just this one.

import { useEffect, useState } from 'react'

const DISMISS_KEY = 'ss.update-dismissed-for'

export default function UpdateBanner() {
  const [show, setShow] = useState(false)
  useEffect(() => {
    // If a previous SW update fired but the user dismissed it for this
    // specific build, stay quiet on subsequent page-loads.
    const dismissed = (() => { try { return localStorage.getItem(DISMISS_KEY) } catch { return null } })()
    const onUpdate = () => {
      if (dismissed === __APP_COMMIT__) return
      setShow(true)
    }
    window.addEventListener('ss:sw-update-available', onUpdate as EventListener)
    return () => window.removeEventListener('ss:sw-update-available', onUpdate as EventListener)
  }, [])
  function dismiss() {
    try { localStorage.setItem(DISMISS_KEY, __APP_COMMIT__) } catch {}
    setShow(false)
  }
  if (!show) return null
  return (
    <div style={{
      position: 'fixed', bottom: 76, left: '50%', transform: 'translateX(-50%)',
      background: 'var(--ink, #1C2A30)', color: '#fff', padding: '10px 16px',
      borderRadius: 999, fontSize: 13, display: 'flex', alignItems: 'center', gap: 12,
      boxShadow: '0 6px 16px rgba(0,0,0,0.25)', zIndex: 200,
      maxWidth: 'calc(100vw - 32px)',
    }}>
      <span>New version available</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: 'var(--accent, #16A34A)', color: '#fff', border: 'none',
          padding: '6px 12px', borderRadius: 6, fontWeight: 600, fontSize: 12, cursor: 'pointer',
        }}
      >Refresh</button>
      <button
        onClick={dismiss}
        aria-label="Dismiss update"
        style={{ background: 'transparent', color: 'rgba(255,255,255,0.6)', border: 'none', cursor: 'pointer', fontSize: 16, padding: '0 4px' }}
      >×</button>
    </div>
  )
}
